/* eslint-disable @typescript-eslint/naming-convention */
import type { AppFooterContent } from '@ps/web-martech-cms-types';
import type { ItemBlock } from '@ps/web-martech-cms-types/AppFooterContent';
import classNames from 'clsx';
import React from 'react';

import { CMSHTML, CMSImage } from '@swf/cms';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../AppFooterContentWidget.scss';

const Item: React.FC<ItemBlock & { alignment: AppFooterContent['item_alignment'] }> = ({
  title,
  image,
  body,
  alignment
}) =>
  title || image.asset || body.content ? (
    <div className={classNames(styles.gridItem, alignment && styles[alignment])}>
      <div className={classNames(styles.header, alignment && styles[alignment])}>
        {image.asset?.url && <CMSImage {...image} className={styles.thumbnailImage} />}
        {title}
      </div>
      <CMSHTML className={styles.body} {...body} />
    </div>
  ) : null;

export default Item;
